/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { OmcPageComponent } from '@src/app/modules/agent/omc-page/omc-page.component';
import { CurrentUserService } from '@src/app/modules/user/current-user.service';
import { TenantService } from '@src/app/shared/tenant.service';
import { OmcPageNavRoute } from '@src/app/routes/omc-page-nav';

@Component({
    selector: 'app-logo',
    templateUrl: './logo.component.html',
    imports: [RouterLink, MatTooltip]
})
export class LogoComponent {

    tenantSvc = inject(TenantService);
    /** ['localhost', './assets/clg-logo-230x63.png'], */
    /**         ['localhost', './assets/ouromc-v3.png'], */
    defaultLogo = '/assets/ouromc-v4.png';
    //defaultLogo = 'https://clgassets.fra1.cdn.digitaloceanspaces.com/logos/agt-casey-kennedy.png';
    //defaultLogo = 'https://clgassets.fra1.cdn.digitaloceanspaces.com/logos/agt-mums.png';

    customLogos = new Map<string, string>([
        ['my.greendoor.ie', './assets/greendoor-logo.jpg'],
        ['mypetra.ie', './assets/petra.png']
    ]);
    customLogo: string;
    link: (string | unknown)[] | null = ['/'];

    constructor() {
        const currentUserSvc = inject(CurrentUserService);

        if (this.customLogos.has(window.location.hostname)) {
            this.customLogo = this.customLogos.get(window.location.hostname);
        } else {
            this.customLogo = this.defaultLogo;
        }
        currentUserSvc.getCurrentUser().pipe(takeUntilDestroyed()).subscribe( user => {
            const agentPosition = currentUserSvc.getAgentPosition();
            if (!user || user.inAgency || !agentPosition) {
                this.link = ['/'];
            } else {
                const route = OmcPageNavRoute.getForceListRouteName(agentPosition.teamId);
                this.link = [route, { _view: OmcPageComponent.defaultView }];
            }
        })
    }
}
